import * as React from "react";

// // // //

function replaceScaleY(inputString: string): string {
    return inputString.replace(/scaleY\(\d+(\.\d+)?\)/g, "scaleY(1.0)");
}

export function getModifiedDragAndDropStyles(
    style: React.CSSProperties,
    options?: { isDragging?: boolean },
): React.CSSProperties {
    // Identify the actively-dragged row. Callers set `opacity: 0.8` on it, so
    // fall back to that when `isDragging` isn't passed explicitly.
    const isDragging = options?.isDragging ?? style.opacity === 0.8;

    return {
        ...style,
        // Only the dragged row is lifted above its siblings. The rows are
        // position:static flex items (which still honor z-index), so this must
        // be a real numeric value — the previous `"200 !important"` string was
        // an invalid CSS value and was silently dropped, leaving the dragged row
        // beneath the rows painted after it in the DOM (the drag "ghosting").
        zIndex: isDragging ? 200 : undefined,
        filter:
            style.transform === undefined
                ? undefined
                : "drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1))",
        transform:
            style.transform === undefined
                ? undefined
                : replaceScaleY(style.transform),
    };
}
